import { createFileRoute } from '@tanstack/react-router'
import { ResourcesIndexPage } from '@/features/resources/components/resources-index-page'
import { buildResourcesIndexHead } from '@/features/resources/seo/resource-seo'

export const Route = createFileRoute('/resources/')({
  head: () => buildResourcesIndexHead(),
  component: ResourcesIndexPage,
  staticData: { layout: 'public' },
})
